module.exports = __webpack_public_path__ + "static/img/core-1.c71e217a.png";